export default () => {
    const groups = [...document.querySelectorAll('.js-step-by-step__accordion')];
    const getItemElements = (item) => {
        const toggle = item.firstElementChild;

        return {
            toggle,
            content: toggle.nextElementSibling,
        };
    };

    const getInnerHeight = (content) => {
        const wasHidden = content.hasAttribute('hidden');

        if (wasHidden) {
            content.removeAttribute('hidden');
        }

        const height = content.children[0].clientHeight;

        if (wasHidden) {
            content.setAttribute('hidden', '');
        }

        return height;
    };

    const getContentHeight = (group, content) => {
        if (!group.classList.contains('js-accordion-fixed-height')) {
            return getInnerHeight(content);
        }

        return Math.max(...[...group.children].map((item) => getInnerHeight(getItemElements(item).content)));
    };

    const getTallestItem = (group) => {
        return [...group.children].reduce((tallestItem, currentItem) => {
            if (!tallestItem) {
                return currentItem;
            }

            const tallestHeight = getInnerHeight(getItemElements(tallestItem).content);
            const currentHeight = getInnerHeight(getItemElements(currentItem).content);

            return currentHeight > tallestHeight ? currentItem : tallestItem;
        }, null);
    };

    const getDefaultItem = (group) => {
        const defaultOpen = group.dataset.defaultOpen;

        if (defaultOpen === 'none') {
            return null;
        }

        if (defaultOpen === 'largest') {
            return getTallestItem(group);
        }

        return group.firstElementChild;
    };

    const setItemState = (item, group, isOpen, hideImmediately = false) => {
        const { toggle, content } = getItemElements(item);

        item.classList.toggle('is-open', isOpen);
        toggle.setAttribute('aria-expanded', isOpen ? 'true' : 'false');

        if (isOpen) {
            content.removeAttribute('hidden');
            content.style.height = getContentHeight(group, content) + 'px';
            return;
        }

        content.style.height = 0;

        if (hideImmediately) {
            content.setAttribute('hidden', '');
        }
    };

    const setModuleHeight = (group) => {
        const panel = group.closest('.step-by-step__panel');
        const contentColumn = group.closest('.step-by-step__content-column');

        if (!panel || !contentColumn) {
            return;
        }

        panel.style.setProperty('--step-by-step-height', `${contentColumn.offsetHeight}px`);
    };

    const resizeObserver = new ResizeObserver((entries) => {
        entries.forEach((entry) => {
            const item = entry.target.parentNode;

            if (item.classList.contains('is-open')) {
                entry.target.style.height = getContentHeight(item.parentNode, entry.target) + 'px';
            }
        });
    });

    groups.forEach((group) => {
        const defaultItem = getDefaultItem(group);
        const items = [...group.children];

        items.forEach((item) => {
            const { toggle, content } = getItemElements(item);

            resizeObserver.observe(content);

            toggle.addEventListener('click', () => {
                if (item.classList.contains('is-open')) {
                    setItemState(item, group, false);
                    setModuleHeight(group);
                    return;
                }

                items.forEach((currentItem) => setItemState(currentItem, group, false));
                setItemState(item, group, true);
                setModuleHeight(group);
            });

            content.addEventListener('transitionend', () => {
                if (!item.classList.contains('is-open')) {
                    content.setAttribute('hidden', '');
                }
            });
        });

        items.forEach((item) => setItemState(item, group, false, true));

        if (defaultItem) {
            setItemState(defaultItem, group, true);
        }

        setModuleHeight(group);
    });

    window.addEventListener('resize', () => {
        groups.forEach((group) => {
            const openItem = group.querySelector('.accordion__item.is-open');

            if (openItem) {
                setItemState(openItem, group, true);
            }

            setModuleHeight(group);
        });
    });
}